import { useNavigate } from "react-router-dom";
import { PageDataType } from "./data";
import {
  ButtonSize,
  TransparentCTAButton,
} from "../../../shared/CTAButtonComponents";
import { useEffect, useRef, useState } from "react";
import { VStack } from "../../../shared/utils";
import { handleClickForTracking } from "../../../analytics";
import { AnalyticsConstant } from "../../../AnalyticsContant";
import { trackEvent } from "../../../utils/AmpAnalytics";

type SectionProps = PageDataType & {
  imageFirst?: boolean; // New prop to control the order of the image
};

export function PageData({
  header,
  subheader,
  bulletPoints,
  imagePath,
  imageFirst = true, // Default to true (image first)
  bgColor,
}: SectionProps) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (!isLoading) {
      setTimeout(() => setIsLoading(false), 0);
    }
  }, [isLoading]);

  return (
    <div
      className={`flex flex-col md:flex-row items-center gap-8 ${
        imageFirst ? "p-8 pl-0" : "p-8 pr-0"
      } `}
      style={{ backgroundColor: `${bgColor ? bgColor : "#ffffff"}` }}
    >
      {imageFirst ? (
        <>
          {/* Image Section (2/3rd space) */}
          <div className="w-full md:w-2/3 rounded-r-xl border-l-0 pl-0 p-[6px] bg-gradient-to-r from-blue-900 to-blue-600 mask-image-[linear-gradient(white, white)]">
            <div className="bg-white rounded-xl relative">
              <img
                src={imagePath}
                alt={header}
                className="w-full h-auto rounded-r-lg"
                onLoad={() => {
                  setIsLoading(false);
                }}
                onError={() => {
                  setIsLoading(false);
                }}
              />
              {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-60 rounded-xl">
                  <img
                    src="/media/gif/loader.gif"
                    alt="Loading animation"
                    width="50"
                  />
                </div>
              )}
            </div>
          </div>
          {/* Text Section (1/3rd space) */}
          <div className="w-full md:w-1/3 flex flex-col pl-6 md:pl-0">
            <h2 className="text-2xl font-bold text-gray-800">{header}</h2>
            <p className="text-gray-700">{subheader}</p>
            <ul className="mt-4 list-disc list-inside text-gray-600 md:pl-4 text-sm">
              {bulletPoints.map((point) => (
                <li className="mb-3 text-justify" key={point}>
                  {point}
                </li>
              ))}
            </ul>
            <TransparentCTAButton
              className="w-28 ml-6 flex justify-start text-center rounded-md px-auto text-primary border-primary py-2 mt-2 hover:border-primary"
              buttonSize={ButtonSize.SMALL}
              type="button"
              onClick={() => {
                handleClickForTracking(AnalyticsConstant.book_a_demo_button);
                trackEvent("Booking a Demo");
                navigate(`/landing/demo`);
              }}
            >
              <span className="w-full text-xs leading-0">{"Book a Demo"}</span>
            </TransparentCTAButton>
          </div>
        </>
      ) : (
        <>
          {/* Text Section (1/3rd space) */}
          <div className="w-full md:w-1/3 flex flex-col pr-6 md:pr-0">
            <h2 className="text-2xl font-bold text-gray-800">{header}</h2>
            <p className="text-gray-700">{subheader}</p>
            <ul className="list-disc list-inside text-gray-600 md:pl-4 mt-4 text-sm">
              {bulletPoints.map((point) => (
                <li className="mb-3 text-justify" key={point}>
                  {point}
                </li>
              ))}
            </ul>
            <TransparentCTAButton
              className="w-28 ml-6 flex justify-start text-center rounded-md px-auto text-primary border-primary py-2 mt-2 hover:border-primary"
              buttonSize={ButtonSize.SMALL}
              type="button"
              onClick={() => {
                // handleClickForTracking(AnalyticsConstant.book_a_demo_button);
                trackEvent("Booking a Demo");
                navigate(`/landing/demo`);
              }}
            >
              <span className="w-full text-xs leading-0">{"Book a Demo"}</span>
            </TransparentCTAButton>
          </div>
          {/* Image Section (2/3rd space) */}
          {
            <div className="w-full md:w-2/3 rounded-l-xl border-l-0 pr-0 p-[6px] bg-gradient-to-r from-blue-900 to-blue-600 mask-image-[linear-gradient(white, white)]">
              <div className="bg-white rounded-xl relative">
                <img
                  src={imagePath}
                  alt={header}
                  className="w-full h-auto rounded-l-lg shadow-lg"
                  onLoad={() => {
                    setIsLoading(false);
                  }}
                  onError={() => {
                    setIsLoading(false);
                  }}
                />
                {isLoading && (
                  <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-60 rounded-xl">
                    <img
                      src="/media/gif/loader.gif"
                      alt="Loading animation"
                      width="50"
                    />
                  </div>
                )}
              </div>
            </div>
          }
        </>
      )}
    </div>
  );
}
